














import { Component, Vue } from "vue-property-decorator";
import { ProductInstanceResult } from "@futuri/cloudsso-client/src/client/types/productInstances";

@Component
export default class DirectLinks extends Vue {
  get directInstances() {
    const instances: ProductInstanceResult[] = this.$store.getters
      .availableInstances;
    const keys = new Set(
      this.$store.getters.portalData?.directProductKeys || []
    );
    const res = instances.filter(inst => keys.has(inst.instanceId)) || [];

    return res;
  }

  handleLink(event: MouseEvent) {
    const instances: ProductInstanceResult[] = this.$store.getters
      .availableInstances;
    const link = event.srcElement as HTMLLinkElement;
    const instance = instances.filter(
      inst => inst.instanceId === link.dataset.inst
    )[0];
    if (!instance) {
      return;
    }

    const { redirectUrl } = instance;
    console.log("Opening direct product link: ", redirectUrl);
    window.open(redirectUrl);
  }
}
